import { QueryClient } from '@tanstack/react-query';
import { GetServerSideProps } from 'next';
import { ReactElement } from 'react';
import styled from 'styled-components';

import { NextPageWithLayout } from '../components/layouts';
import LandingPageLayout from '../components/layouts/LandingPageLayout';
import SafeAiInCuripodPage from '../components/SafeAiInCuripodPage';
import {
  detectAndBestEffortSetLanguage,
  getLocaleRedirectIfNeeded,
} from '../utils/localisationUtils';
import { dehydrateReactQueryPrefetchedInfiniteQuery } from '../utils/react-query-utils';

const TITLE = 'Safe AI in Curipod - Teacher-controlled AI for learning';
const DESCRIPTION =
  'Learn how Curipod uses AI safely: teacher-controlled lessons, rubric-aligned feedback, student privacy safeguards, and transparent model use.';

const SafeAiPage: NextPageWithLayout = () => {
  return (
    <Container>
      <LandingPageLayout
        hideBlobs={true}
        disableHeadline={true}
        title={TITLE}
        subTitle={DESCRIPTION}
      >
        <SafeAiInCuripodPage />
      </LandingPageLayout>
    </Container>
  );
};

const Container = styled.div`
  min-height: 100vh;
`;

export const getServerSideProps: GetServerSideProps = async context => {
  const localeRedirect = getLocaleRedirectIfNeeded(context, '/safe-ai-in-curipod');
  if (localeRedirect) return localeRedirect;

  const queryClient = new QueryClient();

  return {
    props: {
      dehydratedState: dehydrateReactQueryPrefetchedInfiniteQuery(queryClient),
      ...(await detectAndBestEffortSetLanguage(context, { routeClass: 'marketing' })),
    },
  };
};

SafeAiPage.getLayout = function getLayout(page: ReactElement) {
  return <>{page}</>;
};

export default SafeAiPage;
